/**
 * Resolves the Sentry `environment` tag for client and server SDK init.
 * Replaces the Next.js SDK default (`vercel-` plus env), which splits server and
 * browser names on some hosts.
 */

/**
 * Maps a Vercel git ref to a Sentry environment name when `NEXT_PUBLIC_VERCEL_ENV`
 * is `preview`.
 * @param ref `NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF` or a pipeline head branch name.
 * @returns `preview` for `dev` or empty ref; otherwise slashes become dashes.
 */
export function gitCommitRefToSentryEnvironment(ref: string): string {
  const trimmed = ref.trim();
  if (trimmed.length === 0 || trimmed === 'dev') {
    return 'preview';
  }
  return trimmed.replace(/\//g, '-');
}

/**
 * Reads `NEXT_PUBLIC_VERCEL_ENV` and `NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF` and
 * returns the Sentry environment name for the current deployment.
 * @returns Sentry environment string.
 */
export function getSentryEnvironment(): string {
  const vercelEnv = process.env.NEXT_PUBLIC_VERCEL_ENV?.trim();
  if (vercelEnv === 'production') {
    return 'production';
  }
  if (vercelEnv === 'preview') {
    const ref = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF?.trim() ?? '';
    return gitCommitRefToSentryEnvironment(ref);
  }
  return 'development';
}
